import { useEffect, useContext } from 'react';
import { processOutbox } from 'utils/outbox';
import { AuthContext } from 'context';
import { useToast } from 'hooks/useToast';
import { useCookies } from 'react-cookie';
import { Toast } from 'components/Toast';
const OutboxProcessor = () => {
  const { authContext } = useContext(AuthContext);
  const isAuthenticated = authContext?.isAuthenticated;
  const [cookie] = useCookies();
  const { toastList, setToastList } = useToast();
  useEffect(() => {
    if (!isAuthenticated) return;

    processOutbox(cookie, setToastList);

    const handleOnline = () => processOutbox(cookie, setToastList);
    window.addEventListener('online', handleOnline);

    const interval = setInterval(() => processOutbox(cookie, setToastList), 3600000);

    return () => {
      window.removeEventListener('online', handleOnline);
      clearInterval(interval);
    };
  }, [isAuthenticated, cookie, setToastList]);

  return <Toast dismissTime={5000} autoDelete toastList={toastList} />;
};

export { OutboxProcessor };
